angular.module('tgaAdmin').directive('numberValue', () => ({
  priority: 1,
  restrict: 'A',
  require: 'ngModel',
  link(scope, element, attr, ngModel) {
    ngModel.$parsers.push(_.toNumber);
    ngModel.$formatters.push(_.toString);
  },
}));
